import Types from "./types";

export const sendSucceeded = (queueId, entityId, url = null) => ({
	type: Types.QUEUE_SEND_SUCCEEDED,
	payload: {
		queueId,
		entityId,
		url,
	},
});

export const sendFailed = (id, error = null, isPermanent = false) => ({
	type: Types.QUEUE_SEND_FAILED,
	payload: {
		id,
		error,
		isPermanent,
	},
});

export const sendRequested = () => ({
	type: Types.QUEUE_SEND_REQUESTED,
});

export const addQueueItem = (item) => ({
	type: Types.QUEUE_ITEM_ADDED,
	payload: item,
});

/** Restore pending offline sync items after re-login (resets retry counters). */
export const restoreQueueItems = (items) => ({
	type: Types.QUEUE_ITEMS_RESTORED,
	payload: items,
});

export const checkNetworkConnection = () => ({
	type: Types.CHECK_NETWORK_CONNECTION,
});

export const networkChanged = (online) => ({
	type: Types.QUEUE_NETWORK_CHANGED,
	payload: online,
});

export const retryQueueItem = (id) => ({
	type: Types.QUEUE_ITEM_RETRY,
	payload: id,
});

export const removeQueueItem = (id) => ({
	type: Types.QUEUE_ITEM_REMOVED,
	payload: id,
});
